import { PurchaseOrderStatusEnum } from "@finway-group/shared/lib/models"
import { insertIf } from "@finway-group/shared/lib/utils"
import { Tabs } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { Loading } from "~Components/loading"
import { PurchaseOrder } from "~Features/pages/purchaseOrders/types/PurchaseOrder.interfaces"
import { LinkedDeliveryNoteSection } from "./components/LinkedDeliveryNoteSection"
import { LinkedInvoicesSection } from "./components/LinkedInvoicesSection"
import { usePurchaseOrderLinksQuery } from "./queries/purchaseOrder.queries"

const poLinkable = (po: PurchaseOrder) => po.state.currentState === PurchaseOrderStatusEnum.FULFILLMENT

export const PurchaseOrderLinksSection = ({
    purchaseOrder,
    openDnDrawer,
    setIsExpenseModalShowing,
}: {
    purchaseOrder: PurchaseOrder
    openDnDrawer: () => void
    setIsExpenseModalShowing: (isShowing: boolean) => void
}) => {
    const { t } = useTranslation()
    const linkable = poLinkable(purchaseOrder)

    const { data: links, isFetching } = usePurchaseOrderLinksQuery(purchaseOrder._id)
    const { invoices = [], deliveryNotes = [] } = links ?? { invoices: [], deliveryNotes: [] }

    const tabItems = [
        ...insertIf(!purchaseOrder.isService, {
            key: "deliveryNotes",
            label: t("purchaseOrders:details.deliveryNotes"),
            children: (
                <LinkedDeliveryNoteSection // keep line breaks
                    onAddDeliveryNote={openDnDrawer}
                    deliveryNotes={deliveryNotes}
                    editable={linkable}
                />
            ),
        }),
        {
            key: "invoice",
            label: t("purchaseOrders:details.invoices"),
            children: (
                <LinkedInvoicesSection // keep line breaks
                    invoices={invoices}
                    onAddInvoice={() => setIsExpenseModalShowing(true)}
                    canAddInvoice={linkable}
                />
            ),
        },
    ]

    if (isFetching) {
        return <Loading />
    }

    return <Tabs defaultActiveKey={"invoice"} items={tabItems} />
}
